import Vue from 'vue';
import { SentryIgnore, SentryIgnoreFileLists } from './index';
import { BiliIntegration } from '@bilibili/sentry-integrations';
// const debug = require('debug')('app:sentry');

export const SENTRY_INITIATIVE_MAIN_LABEL = {
    // 接口关键字段丢失/null/空
    fieldLoss: 'mainFieldLoss',
    href: 'href'
};

export function sentryInit ({dsn}, store) {
    if (process.env.VUE_ENV === 'client' && process.env.NODE_ENV === 'production') {
        if (!window || !window.Sentry) return;
        window.Sentry.init({
            dsn: dsn,
            debug: process.env.NODE_ENV !== 'production',
            // process.env.NODE_ENV !== 'production',
            release: process.env.COMMIT_ID,
            environment: process.env.PUSH_ENV === 'pre' ? 'pre' : process.env.NODE_ENV,
            // enabled: process.env.NODE_ENV === 'production' || process.env.PUSH_ENV === 'pre',
            sampleRate: 0.5,
            integrations: [
                new BiliIntegration({
                    ignoreFileNameList: SentryIgnoreFileLists
                }),
                new window.Sentry.Integrations.InboundFilters({
                    ignoreErrors: SentryIgnore
                }),
                new window.Sentry.Integrations.Vue({
                    Vue,
                    attachProps: true
                })
            ]
        });
    }
}

export function isSentryMainFieldLoss(field, error = '关键字段异常', extra = {}) {
    if (field instanceof Array) {
        if (field.length) return false;
        else {
            sentryInitiativeReport(SENTRY_INITIATIVE_MAIN_LABEL.fieldLoss, error, extra);
            return true;
        }
    } else if (field) return false;

    sentryInitiativeReport(SENTRY_INITIATIVE_MAIN_LABEL.fieldLoss, error, extra);
    return true;
}

/**
 * 业务监控上报
 *
 * @export
 * @param {string} [label=''] 业务代码唯一标识
 * @param {*} error 错误信息
 */
export function sentryInitiativeReport(label = '', error = '异常', extra = {}) {
    if (process.env.VUE_ENV === 'client') {
        if (!window || !window.Sentry) return;
        window.Sentry.withScope(function(scope) {
            scope.setTag('initiative', label);

            if (extra) {
                Object.keys(extra).forEach(key => {
                    scope.setExtra(key, extra[key]);
                });
            }

            // debug('sentry上报中：', error);
            window.Sentry.captureException(error instanceof Error ? error : new Error(error));
        });
    }
}